import { TaxiCorporationListItem } from "../../../../../../common/services/taxi-corporation/list/taxi-corporation-list";
import billingsTaxiRouteListingFactory from "../../common/billings-taxi-route-listing.factory";
import BillingsTaxiRouteListingByRailyTaxiCorporationSelectOption from "./types/billings-taxi-route-listing-by-raily-taxi-corporation-select-option";

const createTaxiCorporationSelectOption = (
  responseTaxiCorporation: TaxiCorporationListItem,
): BillingsTaxiRouteListingByRailyTaxiCorporationSelectOption => {
  return {
    label: responseTaxiCorporation.displayName,
    value: {
      uuid: responseTaxiCorporation.uuid,
      displayName: responseTaxiCorporation.displayName,
    },
  };
};

const createTaxiCorporationSelectOptions = (
  responseTaxiCorporations: TaxiCorporationListItem[],
): BillingsTaxiRouteListingByRailyTaxiCorporationSelectOption[] => {
  return responseTaxiCorporations.map(createTaxiCorporationSelectOption);
};

const billingsTaxiRouteListingByRailyFactory = {
  createTaxiCorporationSelectOptions,
  createListingItems: billingsTaxiRouteListingFactory.createListingItems,
  createStatsSummary: billingsTaxiRouteListingFactory.createStatsSummary,
};

export default billingsTaxiRouteListingByRailyFactory;
